import React from 'react';
import { getDefaultName } from "../../helper/setDefaultName";
import _ from 'lodash';
import { strFormatChange } from '../../helper/stringHelper';
import { _maxPrefix } from '../../helper/split';
import { ICTypes } from '../../../pages/Sierra/constants';

function getSelectedInterfaces({
  name,
  pcbInterfaceInfo,
  selectedSignalKeys,
  mergeAllSignal,
  connInterfaces,
  interfaceList,
  type
}) {

  if (type === "single") {
    return singleInterfaceCreate({
      name,
      pcbInterfaceInfo,
      mergeAllSignal
    })
  }
  let selectedInterfaces = [];

  if (interfaceList && interfaceList.length) {
    selectedInterfaces = JSON.parse(JSON.stringify(interfaceList))
    for (let info of selectedInterfaces) {
      for (let intItem of info.interfaces || []) {
        let newContent = [];
        intItem.content.forEach(item => {
          if (!newContent.find(it => _.isEqual(it, item))) {
            newContent.push(item)
          }
        }
        );
        intItem.content = newContent;
      }
    }
    return selectedInterfaces;
  } else if (connInterfaces && connInterfaces.length && selectedSignalKeys.length) {
    if (mergeAllSignal) {
      let interfaceObj = {}, groupNames = [];
      // const showGroup = connInterfaces.filter(item => selectedSignalKeys.includes(item.index)).length > 1;
      const showGroup = true;
      for (let _conn of connInterfaces) {

        if (!selectedSignalKeys.includes(_conn.index)) {
          continue;
        }

        const signalNames = _conn.dataList.map(item => item.signalName);
        let groupName = "";

        for (let conn of _conn.dataList || []) {

          for (let pcbId of conn.pcbConns || []) {

            const signals = conn.signalList[pcbId] || [];
            const signal = signals[0] || {};

            if (showGroup && !groupName) {
              groupName = getDefaultSignalGroupName({
                signalNames: signalNames,
                groupNames,
                interfaceType: signal.type
              });
              groupName && groupNames.push(groupName);
            }

            const nets = [...signals.map(item => item.nets).flat(2)];
            if (!interfaceObj[pcbId]) {
              interfaceObj[pcbId] = {
                content: [{ name: conn.signalName, nets: [...nets], signalType: signal.signalType, signalGroup: groupName }],
                type: signal.type,
                interfaceName: conn.signalName || name || signal.type,
                designId: pcbId
              }
            } else {
              const newSignal = { name: conn.signalName, nets: [...nets], signalType: signal.signalType, signalGroup: groupName };
              if (!interfaceObj[pcbId].content.find(item => _.isEqual(item, newSignal))) {
                interfaceObj[pcbId].content.push({ name: conn.signalName, nets: [...nets], signalType: signal.signalType, signalGroup: groupName });
              }
            }
          }
        }
      }
      const interfaces = Object.keys(interfaceObj).map(item => interfaceObj[item]);
      let interfaceName = interfaces[0] ? interfaces[0].interfaceName : "";

      selectedInterfaces.push({
        interfaceName: name || interfaceName,
        interfaces,
        type: interfaces[0] ? interfaces[0].type : ""
      })
    } else {
      const groupNames = [];
      for (let conn of connInterfaces) {
        let interfaceObj = {};
        if (!selectedSignalKeys.includes(conn.index)) {
          continue;
        }
        const signalNames = conn.dataList.map(item => item.signalName);
        let groupName = "";
        const dataList = conn.dataList || [];
        for (let i = 0; i < dataList.length; i++) {
          const signalItem = dataList[i];
          if (!signalItem) {
            continue;
          }
          for (let pcbId of signalItem.pcbConns) {
            if (!signalItem.signalList) {
              continue;
            }
            const pcbSignals = signalItem.signalList[pcbId] || [];
            const signalName = signalItem.signalName;

            const _signal = pcbSignals[0] || {};
            const nets = pcbSignals.length ? [...pcbSignals.map(item => item.nets).flat(2)] : [];

            if (!groupName) {
              groupName = getDefaultSignalGroupName({
                signalNames: signalNames,
                groupNames,
                interfaceType: _signal.type
              });
              groupName && groupNames.push(groupName);
            }
            if (!interfaceObj[pcbId]) {
              interfaceObj[pcbId] = {
                content: [{ name: signalName, nets: [...nets], signalType: _signal.signalType, signalGroup: groupName }],
                type: _signal.type,
                interfaceName: signalName || _signal.type,
                designId: pcbId
              }
            } else {
              const newSignal = { name: signalName, nets: [...nets], signalType: _signal.signalType, signalGroup: groupName };
              if (!interfaceObj[pcbId].content.find(item => _.isEqual(item, newSignal))) {
                interfaceObj[pcbId].content.push({ name: signalName, nets: [...nets], signalType: _signal.signalType, signalGroup: groupName });
              }
            }
          }
        }
        const interfaces = Object.keys(interfaceObj).map(item => interfaceObj[item]);
        let interfaceName = interfaces[0].interfaceName;

        selectedInterfaces.push({
          interfaceName: interfaceName,
          interfaces,
          type: interfaces[0].type
        })
      }
    }
  }

  return selectedInterfaces;
}

function singleInterfaceCreate({
  name,
  pcbInterfaceInfo,
  mergeAllSignal
}) {
  let selectedInterfaces = [];
  if (mergeAllSignal) {
    let interfaces = [], type = "", signalNames = [], groupNames = [];
    for (let pcbId of Object.keys(pcbInterfaceInfo)) {
      let filterSelectedInterfaces = (pcbInterfaceInfo[pcbId].allInterfaceCompNetData || []).filter(item => (pcbInterfaceInfo[pcbId].selectKeys || []).includes(item.interfaceKey));
      let newInterface = {};
      // const showGroup = filterSelectedInterfaces.length > 1;
      const showGroup = true;

      for (let info of JSON.parse(JSON.stringify(filterSelectedInterfaces))) {
        //add first interface
        if (!Object.keys(newInterface).length) {
          newInterface = {
            type: info.type,
            interfaceName: info.name,
            designId: pcbId,
            content: []
          }
          type = !type ? info.type : type;
        }

        ///add signals
        const groupName = showGroup ? getDefaultSignalGroupName({ signalNames: info.content.map(item => item.signalMergeName), groupNames, interfaceType: info.type }) : "";
        groupName && groupNames.push(groupName);
        for (let item of info.content) {
          const { signalMergeName, signalType, nets, } = item;
          let name = signalMergeName;
          //get signal name
          if (signalNames.includes(signalMergeName)) {
            name = getDefaultName({
              nameList: signalNames,
              firstIndex: 1,
              key: "",
              delimiter: "_",
              defaultKey: signalMergeName
            })
          }
          signalNames.push(item.name);
          newInterface.content.push({ name, nets: [...nets], signalType, signalGroup: groupName, });
        }
      }
      interfaces.push(newInterface);
    }

    selectedInterfaces.push({
      interfaces,
      interfaceName: name || type,
      type
    })
  } else {
    for (let pcbId of Object.keys(pcbInterfaceInfo)) {
      const groupNames = [];
      const interfaces = (pcbInterfaceInfo[pcbId].allInterfaceCompNetData || [])
        .filter(item => (pcbInterfaceInfo[pcbId].selectKeys || []).includes(item.interfaceKey))
        .map(info => {
          let signalNames = [], interfaceName = "";
          const groupName = getDefaultSignalGroupName({ signalNames: info.content.map(item => item.signalMergeName), groupNames, interfaceType: info.type });
          const content = info.content.map(it => {
            let name = it.signalMergeName || it.nets[0];
            //get signal name
            if (signalNames.includes(name)) {
              name = getDefaultName({
                nameList: signalNames,
                firstIndex: 1,
                key: "",
                delimiter: "_",
                defaultKey: name
              })
            }
            signalNames.push(name);
            if (!interfaceName) {
              interfaceName = name;
            }
            return { name, nets: [...it.nets], signalType: it.signalType, signalGroup: groupName }
          })
          return {
            interfaces: [{
              type: info.type,
              interfaceName,
              designId: pcbId,
              content
            }],
            type: info.type,
            interfaceName
          }
        })
      selectedInterfaces.push(...interfaces);
    }
  }
  return selectedInterfaces;
}

function getDefaultMasterComp({ interfaceParams, pcbComponents }) {
  let maxSignalCount = -1;
  let maxPinCount = -1;
  let masterComp = "";

  for (const _interface of interfaceParams) {
    const ICComps = _interface.content.components.filter(item => ICTypes.includes(item.type));
    const componentToPinCount = {}; // { compName: pinCount }
    const componentToSignalCount = {}; // { compName: [] }
    for (const mc of ICComps) {
      const componentsList = pcbComponents[_interface.designId] ? pcbComponents[_interface.designId] : null;
      const component = (componentsList || []).find(item => item.name === mc.name);
      if (component && component.pinList) {
        const pinCount = component.pinList.length;
        componentToPinCount[mc.name] = pinCount;
        componentToSignalCount[mc.name] = (mc.pins || []).map(pin => pin.signal).filter((value, index, self) => self.indexOf(value) === index); // unique signals
        // if (pinCount > maxPinCount) {
        //   maxPinCount = pinCount;
        //   masterComp = `${mc.name}::${_interface.designId}`;
        // }
      }
    }

    for (const compName of Object.keys(componentToSignalCount)) {
      const signalCount = componentToSignalCount[compName].length;
      if (signalCount > maxSignalCount) {
        maxSignalCount = signalCount;
      }
    }

    for (const compName of Object.keys(componentToSignalCount)) {
      const signalCount = componentToSignalCount[compName].length;
      if (signalCount === maxSignalCount) {
        const pinCount = componentToPinCount[compName];
        if (pinCount > maxPinCount) {
          maxPinCount = pinCount;
          masterComp = `${compName}::${_interface.designId}`;
        }
      }
    }
  }

  return masterComp;
}

function getSearchAdvancedSetup({ pcbConfig, applySetupAll, pcbId }) {
  if (!applySetupAll || !pcbConfig) {
    return {};
  }
  const pcbIds = Object.keys(pcbConfig || {});
  if (!pcbIds.length) {
    return {};
  }
  const setup = pcbId && pcbConfig[pcbId] ? pcbConfig[pcbId] : pcbConfig[pcbIds[0]];

  return { type: setup.interfaceType, setting: { ...(JSON.parse(JSON.stringify(setup.advancedConfig || {}))) } }
}

function filterExistedSignals(signals, filterConns) {
  let filterSignals = [];
  for (let signal of signals) {
    const findSignal = filterConns.find(item => signal.nets.every(net => item.nets.includes(net)));
    if (!findSignal) {
      filterSignals.push(signal)
    }
  }
  return filterSignals;
}

const NEW_INTERFACE = 2;
function addSelectedSignalsToInterface({ interfaceList, interfaceName, pcbInterfaceInfo, channelList = [] }) {
  let _interfaceList = [...interfaceList], _pcbInterfaceInfo = { ...pcbInterfaceInfo };
  const interfaceNames = [...interfaceList.map(item => item.interfaceName), ...channelList.map(item => item.name)];
  const index = interfaceName === NEW_INTERFACE ? -1 : _interfaceList.findIndex(item => item.interfaceName === interfaceName);

  if (index < 0 && interfaceName !== NEW_INTERFACE) {
    return { _interfaceList, _pcbInterfaceInfo }
  }
  const interfaces = interfaceName === NEW_INTERFACE ? [] : _interfaceList[index].interfaces || [];

  const signalNames = interfaces.map(item => item.content).flat(2).map(item => item.name);
  let verType = null;

  for (let pcbId of Object.keys(_pcbInterfaceInfo)) {
    if (!_pcbInterfaceInfo[pcbId].selectKeys.length) {
      continue;
    }
    const selectKeys = [..._pcbInterfaceInfo[pcbId].selectKeys];
    const dataList = _pcbInterfaceInfo[pcbId].allInterfaceCompNetData.filter(item => selectKeys.includes(item.interfaceKey))
    _pcbInterfaceInfo[pcbId].selectKeys = [];
    if (!dataList.length) {
      continue;
    }
    const interIndex = interfaces.findIndex(item => item.designId === pcbId);
    const signals = dataList.map(item => item.content).flat(2);
    verType = !verType ? dataList[0].type : verType;
    if (interIndex < 0) {
      interfaces.push({
        content: [...signals.map(item => {
          let signalName = item.signalMergeName;
          if (signalNames.includes(signalName)) {
            signalName = getDefaultName({ nameList: signalNames, key: "", defaultKey: signalName, firstIndex: 1, delimiter: "_" });
          }
          signalNames.push(signalName)
          return {
            name: signalName,
            nets: [...item.nets]
          }
        })],
        designId: pcbId,
        interfaceName,
        type: dataList[0].type
      })
    } else {
      const filterSignals = filterExistedSignals(signals, interfaces[interIndex].content);
      interfaces[interIndex].content.push(...filterSignals.map(item => {
        let signalName = item.signalMergeName;
        if (signalNames.includes(signalName)) {
          signalName = getDefaultName({ nameList: signalNames, key: "", defaultKey: signalName, firstIndex: 1, delimiter: "_" });
        }
        signalNames.push(signalName)
        return {
          name: signalName,
          nets: [...item.nets]
        }
      }))
    }
  }
  if (interfaceName === NEW_INTERFACE) {
    let newInterfaceName = verType || "Interface";
    if (interfaceNames.includes(newInterfaceName)) {
      newInterfaceName = getDefaultName({ nameList: interfaceNames, key: "", defaultKey: newInterfaceName, firstIndex: 1 })
    }
    _interfaceList.push({
      type: verType,
      interfaceName: newInterfaceName,
      interfaces,
      signalNames: []
    })
  } else {
    _interfaceList[index].interfaces = interfaces;
  }

  return { _interfaceList, _pcbInterfaceInfo }
}

function addSelectedSignalsToConnTable({ connInterfaces, interfaceName, pcbInterfaceInfo }) {
  let _connInterfaces = [...connInterfaces], _pcbInterfaceInfo = { ...pcbInterfaceInfo };
  const index = _connInterfaces.find(item => item.interfaceName === interfaceName);
  if (index < 0) {
    return { _connInterfaces, _pcbInterfaceInfo }
  }

  const signalNames = _connInterfaces.map(item => item.signalName);

  for (let pcbId of Object.keys(_pcbInterfaceInfo)) {
    if (!_pcbInterfaceInfo[pcbId].selectKeys.length) {
      continue
    }
    const selectKeys = [..._pcbInterfaceInfo[pcbId].selectKeys];
    const dataList = _pcbInterfaceInfo[pcbId].allInterfaceCompNetData.filter(item => selectKeys.includes(item.interfaceKey))
    _pcbInterfaceInfo[pcbId].selectKeys = [];
    if (!dataList.length) {
      continue;
    }

    const signals = dataList.map(item => item.content.map(it => { return { ...it, interfaceKey: item.interfaceKey, type: item.type } })).flat(2);
    const filterConns = _connInterfaces.filter(item => !!item.signalList[pcbId]).map(item => item.signalList[pcbId]).flat(2);
    const filterSignals = filterExistedSignals(signals, filterConns);
    if (!filterSignals.length) {
      continue;
    }

    for (let signal of filterSignals) {
      let signalName = signal.signalMergeName;
      if (signalNames.includes(signalName)) {
        signalName = getDefaultName({ nameList: signalNames, key: "", defaultKey: signalName, firstIndex: 1, delimiter: "_" });
      }
      _connInterfaces.push({
        signalType: "add",
        allConnKeys: [],//not need
        index: null,//no need
        pcbConns: [pcbId],
        signal: signal.name,
        signalList: {
          [pcbId]: [{
            name: signal.name,
            signalMergeName: signal.signalMergeName,
            nets: [...signal.nets],
            type: signal.type,
            interfaceKey: signal.interfaceKey
          }]
        },
        signalName,
        signalNetName: signal.signalMergeName
      })
      signalNames.push(signalName)
    }
  }
  return { _connInterfaces, _pcbInterfaceInfo }
}

function getFilterIdentificationLog({
  searchKey,
  messageList
}) {
  let netSearchList = [], searchList = [], logList = [];
  const reg = new RegExp(`${strFormatChange(searchKey)}`, "ig");
  let index = 0;
  for (let log of messageList) {
    const matchLog = log.match(reg);
    index += 1;
    if (!matchLog) {
      logList.push(log);
      continue;
    }
    const matchStr = matchLog[0];
    const logArr = log.split('"');
    let netName = logArr[1] || "", diffNetName = "";
    if (log.match("differential nets")) {
      diffNetName = logArr[3] || ""
    }

    const logArrBySearch = log.split(matchStr);

    if (netName.match(reg) || diffNetName.match(reg)) {
      const searchEles = getSearchSpanList(logArrBySearch, matchLog, index);
      netSearchList.push(<span>{searchEles.map(item => item)}</span>)
    } else {
      const searchEles = getSearchSpanList(logArrBySearch, matchLog, index);
      searchList.push(<span>{searchEles.map(item => item)}</span>)
    }
  }
  return { searchList: [...netSearchList, ...searchList], logList }
}

function getSearchSpanList(logArrBySearch, matchLog, index) {
  let searchEles = [];
  for (let i = 0; i < logArrBySearch.length; i++) {
    let searchEle = <span key={`${index}_${i}`}>{logArrBySearch[i]}{matchLog[i] ? <font style={{ background: "#ff0" }}>{matchLog[i]}</font> : null}</span>
    searchEles.push(searchEle)
  }
  return searchEles
}

function getDefaultSignalGroupName({ signalNames, groupNames, interfaceType }) {
  const maxPrefixStr = _maxPrefix(signalNames);
  let maxPrefix = "";
  if (maxPrefixStr && !maxPrefixStr.match(/(^Signal$)|(Signal[0-9]+)|(Signal_[0-9]+)/ig)) {
    // eg: I2C_S -> I2C, A_I2C, -> I2C
    const pattern = /^[a-zA-Z0-9]_|_[a-zA-Z0-9]$/;
    maxPrefix = maxPrefixStr.replace(pattern, '');
  };

  let groupName = maxPrefix || interfaceType || "Group1";
  if (maxPrefix) {
    groupName = groupNames.includes(maxPrefix) ? getDefaultName({ nameList: groupNames, defaultKey: maxPrefix, key: "", firstIndex: 1, delimiter: "_" }) : maxPrefix
  } else {
    groupName = getDefaultName({ nameList: groupNames, defaultKey: interfaceType || "Group", key: "", firstIndex: 1 })
  }
  return groupName;
}

export {
  getSelectedInterfaces,
  getSearchAdvancedSetup,
  addSelectedSignalsToInterface,
  addSelectedSignalsToConnTable,
  getFilterIdentificationLog,
  getDefaultMasterComp
}